import { ORDER_METHODS, PaymentMethods } from '../../../../../../services/exports/Constants';

export default {
  title: 'Betalingsmetoder',
  fields: {
    hidden_payment_methods: {
      label: 'Skjulte betalingsmetoder',
    },
    has_online_payments: {
      label: 'Har onlinebetalinger',
    },
    has_paypal_upcharge: {
      label: 'Læg 3,5 % ekstra oveni PayPal-transaktioner',
    },
    has_cash_payments: {
      label: 'Har kontantbetalinger',
    },
    has_occ_cash_payments: {
      label: 'Kontantbetalinger i callcenter aktiveret',
    },
    has_in_store_card_payments: {
      label: 'Har kortbetalinger i butikken',
    },
    overwrite_cash_payments_to_invoice: {
      label: 'Navngiv kontantbetalinger „Faktura“',
    },
  },
  payment_methods: {
    [PaymentMethods.CARD]: 'Kort',
    [PaymentMethods.PAYPAL]: 'PayPal',
    [PaymentMethods.APPLE_PAY]: 'Apple Pay',
    [PaymentMethods.GOOGLE_PAY]: 'GPay',
    [PaymentMethods.SOFORT]: 'Sofort',
    [PaymentMethods.IDEAL]: 'iDEAL | Wero',
    [PaymentMethods.BANCONTACT]: 'Bancontact',
    [PaymentMethods.EPS]: 'EPS',
    [PaymentMethods.P24]: 'Przelewy24',
    [PaymentMethods.BLIK]: 'BLIK',
    [PaymentMethods.TWINT]: 'TWINT',
    [PaymentMethods.VENMO]: 'Venmo',
    [PaymentMethods.WERO]: 'Wero',
    [PaymentMethods.KLARNA]: 'Klarna',
    [PaymentMethods.TRUSTLY]: 'Trustly',
    [PaymentMethods.PIX]: 'Pix',
    [PaymentMethods.NUPAY]: 'NuPay',
    [PaymentMethods.GIROPAY]: 'Giropay',
    [PaymentMethods.SEPA_DEBIT]: 'SEPA-direkte debitering',
    [PaymentMethods.CASH]: 'Kontant',
    [PaymentMethods.BACS_DEBIT]: 'Bacs-direkte debitering',
    [PaymentMethods.PAY_BY_BANK]: 'Betal via bank',
  },
  order_methods: {
    [ORDER_METHODS.pickup]: 'Afhentning',
    [ORDER_METHODS.delivery]: 'Levering',
    [ORDER_METHODS.room_service]: 'Værelses-/bordservice',
  },
  modals: {
    confirmation: {
      title: 'Er du sikker?',
      description:
        'Når du bekræfter, er onlinebetalinger <strong>{{onlineState}}</strong>, og kontantbetalinger er <strong>{{cashState}}</strong>',
    },
  },
  labels: {
    off: 'slået fra',
    on: 'slået til',
  },
  buttons: {
    save: 'Gem',
    configure_online_payments: 'Konfigurer onlinebetalinger',
  },
  toasts: {
    failed_to_save_changes: 'Ændringerne kunne ikke gemmes',
    changes_got_saved: 'Ændringerne er gemt',
  },
};
